import React from 'react';
import styled from 'styled-components';
import Image from '@stencil/image';

import ArrowLeftDetailIcon from '../../../../Icons/ArrowLeftDetailIcon';
import ArrowRightDetailIcon from '../../../../Icons/ArrowRightDetailIcon';
import useCarousel from '../../../../../shared/hooks/useCarousel';

interface IMainGalleryList {
  alternateText: string;
  data: Array<object>;
  onGalleryClick: Function;
  dimension: string;
}

const MainGallery = ({alternateText, data, onGalleryClick, dimension}: IMainGalleryList) => {
  const {dataList, increment, decrement, isLeftCursorActive, isRightCursorActive} = useCarousel(
    data,
    1,
  );

  return (
    <>
      {dimension === 'normalWidth' ? (
        <MainGalleryOuterWrapDiv>
          {dataList.map((item, i) => {
            const conditionalProps: {itemProp?: 'image'} = i === 0 ? {itemProp: 'image'} : {};

            return (
              <HotelMainGalleryImage
                src={item.b}
                alt={alternateText}
                key={item.b || i}
                onClick={() => onGalleryClick('captivate')}
                {...conditionalProps}
              />
            );
          })}

          {(isLeftCursorActive && (
            <LeftArrowGallery onClick={decrement} no-focus-outline>
              <ArrowLeftDetailIcon />
            </LeftArrowGallery>
          )) ||
            ''}
          {(isRightCursorActive && (
            <RightArrowGallery onClick={increment} no-focus-outline>
              <ArrowRightDetailIcon />
            </RightArrowGallery>
          )) ||
            ''}
        </MainGalleryOuterWrapDiv>
      ) : (
        ''
      )}
      {dimension === 'fullWidth' ? (
        <MainGalleryFullWidthDiv>
          {dataList.map((item, i) => {
            const conditionalProps: {itemProp?: 'image'} = i === 0 ? {itemProp: 'image'} : {};
            return (
              <HotelMainGalleryImage
                src={item.b}
                alt={alternateText}
                key={item.b || i}
                onClick={() => onGalleryClick()}
                {...conditionalProps}
              />
            );
          })}

          {(isLeftCursorActive && (
            <LeftArrowGallery onClick={decrement} no-focus-outline>
              <ArrowLeftDetailIcon />
            </LeftArrowGallery>
          )) ||
            ''}
          {(isRightCursorActive && (
            <RightArrowGallery onClick={increment} no-focus-outline>
              <ArrowRightDetailIcon />
            </RightArrowGallery>
          )) ||
            ''}
        </MainGalleryFullWidthDiv>
      ) : (
        ''
      )}
    </>
  );
};

export default MainGallery;

const MainGalleryOuterWrapDiv = styled.div(
  props => `
  position:relative;
  width:65%;
  cursor: pointer;
  margin-right:${props.theme.spacing.large};

`,
);

const MainGalleryFullWidthDiv = styled.div(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: column;
  position:relative;
  width:58rem;
  cursor: pointer;
`,
);

const HotelMainGalleryImage = styled(Image)(
  props => `
    display: flex;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    width: 100%;
    height: 32rem;
    object-fit: cover;
`,
);

const LeftArrowGallery = styled.button(
  props => `
      width:3.5rem;
      height:3.5rem;
      fill: ${props.theme.colors.downriver.base};
      position :absolute;
      top:15rem;
      left:1.4rem;
      background:${props.theme.colors.goWhite.base};
      border-radius:50%;
      padding:1rem;
      border:none;
      z-index: ${props.theme.misc.zIndex.xsmall};
      &: focus {
        outline: 0;
      }
  `,
);

const RightArrowGallery = styled.button(
  props => `
      width:3.5rem;
      height:3.5rem;
      fill: ${props.theme.colors.downriver.base};
      position :absolute;
      top:15rem;
      right:1.4rem;
      background:${props.theme.colors.goWhite.base};
      border-radius:50%;
      padding:1rem;
      border:none;
      z-index: ${props.theme.misc.zIndex.xsmall};
      &: focus {
        outline: 0;
      }
  `,
);
